import { GetWSMgr } from "@/Utils/StateLib";
import { useEffect, useRef } from "react";

export const useTopic = <T extends unknown>(topic: string, callback: (data: T) => void) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const wsMgr = GetWSMgr();
    if (!wsMgr) return;

    return wsMgr.SubscribeToTopic(topic, (data: T) => callbackRef.current(data));
  }, [topic]);
};
